// Geteilter Theme-Store. App.svelte liest die Mode aus und setzt die
// .dark-Klasse aufs <html>. Settings-Page schreibt sie (Auto/Hell/
// Dunkel-Buttons). Persistenz laeuft seit dem prefs-Refactor ueber
// lib/prefs.svelte (Server-SSOT + localStorage-Cache).
//
// Seit 10.10.2026 folgt die Wahl dem GERAET (Tim: "Dem Geraet folgt die
// anpassbare Oberflaeche ... die geoeffneten und angeordneten Tabs und
// Hell/dunkel"): der iMac im hellen Zimmer und das MacBook am Abend
// muessen nicht dasselbe zeigen. Zwei Fenster desselben Geraets gleichen
// sich weiter live ab. index.html liest denselben Wert vor dem ersten Bild.

import { getGeraetPref, setGeraetPref } from "./prefs.svelte";
import { istDunkelBei, naechsterModus } from "./theme-wahl";

export type ThemeMode = "auto" | "light" | "dark";

const KEY = "theme_mode";
// Legacy-Keys aus der pre-prefs-Aera. Werden einmal beim ersten Load
// gemigriert, danach geloescht.
const LEGACY_KEYS = ["theme-mode", "theme"];

let _initialized = false;

function isValid(v: unknown): v is ThemeMode {
  return v === "auto" || v === "light" || v === "dark";
}

function migrateLegacy(): ThemeMode | undefined {
  if (typeof localStorage === "undefined") return undefined;
  for (const k of LEGACY_KEYS) {
    const v = localStorage.getItem(k);
    if (isValid(v)) {
      // In den neuen prefs-Store schieben + Legacy-Key entfernen, damit
      // ein zweiter Start nicht wieder aus dem alten Schluessel liest.
      setGeraetPref(KEY, v);
      localStorage.removeItem(k);
      return v;
    }
  }
  return undefined;
}

function ensureInitialized(): void {
  if (_initialized) return;
  _initialized = true;
  if (getGeraetPref<ThemeMode>(KEY) === undefined) {
    migrateLegacy();
  }
}

export function getThemeMode(): ThemeMode {
  ensureInitialized();
  const v = getGeraetPref<ThemeMode>(KEY);
  return isValid(v) ? v : "auto";
}

export function setThemeMode(m: ThemeMode): void {
  setGeraetPref(KEY, m);
}

// Was das System vorgibt (prefers-color-scheme). Lag bis 04.10.2026 als
// lokaler Zustand in App.svelte; der Umschalter in der Statusleiste
// braucht denselben Wert, also wohnt er jetzt hier.
let _systemDunkel = $state(
  typeof window !== "undefined" && window.matchMedia("(prefers-color-scheme: dark)").matches,
);
if (typeof window !== "undefined") {
  window
    .matchMedia("(prefers-color-scheme: dark)")
    .addEventListener("change", (e) => (_systemDunkel = e.matches));
}

/** Ist die Oberfläche gerade dunkel (feste Wahl oder Auto + System)? */
export function istDunkel(): boolean {
  return istDunkelBei(getThemeMode(), _systemDunkel);
}

/** Wohin der Umschalter führen würde -- für Symbol und Tooltip. */
export function umschaltZiel(): ThemeMode {
  return naechsterModus(getThemeMode(), _systemDunkel);
}

/** Hell <-> Dunkel in einem Klick (Regel in theme-wahl.ts). */
export function schalteHellDunkel(): void {
  setThemeMode(umschaltZiel());
}
